import { render, staticRenderFns } from "./MenuGroupModal.vue?vue&type=template&id=a10a0a9c&scoped=true"
import script from "./MenuGroupModal.vue?vue&type=script&lang=ts"
export * from "./MenuGroupModal.vue?vue&type=script&lang=ts"
import style0 from "./MenuGroupModal.vue?vue&type=style&index=0&id=a10a0a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10a0a9c",
  null
  
)

export default component.exports